import { render, staticRenderFns } from "./UploadProfileBanner.vue?vue&type=template&id=8b156a98&"
import script from "./UploadProfileBanner.vue?vue&type=script&lang=js&"
export * from "./UploadProfileBanner.vue?vue&type=script&lang=js&"
import style0 from "./UploadProfileBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports